import { Flex, Button } from "@radix-ui/themes";
import React from "react";

const NavBar = () => {
  return (
    <div
      style={{
        position: "sticky",
        top: 0,
        height: "50px",
        width: "100%",
        backgroundColor: "black",
        color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        zIndex: 1000, // ensures the navbar stays on top of other content
      }}
    >
      <div
        style={{
          paddingLeft: "20px",
          paddingTop: "8px",
          cursor: "pointer",
        }}
      >
        <img
          src="/tellos_p.png"
          alt="tellos logo"
          style={{ width: "40px", height: "40px", borderRadius: "7px" }}
        />
      </div>
      {/* <div>
        <Flex gap="6" align="center">
          <Button size="2" variant="ghost" style={{ cursor: "pointer" }}>
            Pricing
          </Button>

          <Button size="2" variant="ghost" style={{ cursor: "pointer" }}>
            About
          </Button>
        </Flex>
      </div> */}
      <div style={{ paddingRight: "10px" }}>
        <Flex gap="3" align="center">
          {/* Log In button with inline style */}
          <Button
            size="2"
            variant="ghost"
            style={{
              cursor: "pointer",
              display: "inline-block", // Hide on small screens
            }}
            onClick={() => (window.location.href = "http://app.iamtellos.com")}
          >
            Log In
          </Button>
          <Button
            size="2"
            variant="soft"
            color="green"
            style={{ cursor: "pointer" }}
            onClick={() => (window.location.href = "http://app.iamtellos.com")}
          >
            Start learning
          </Button>
        </Flex>
      </div>
    </div>
  );
};

export default NavBar;
